<template lang="html">
  <app-modal @close="close" class="alert">
    <app-modal-default @close="close">
      <template v-slot:header>
        {{$ml.get('Billing info')}}
        <!-- {{ $ml.get(`Payment method`) }} -->
      </template>
      <template v-slot:content>
        <div class="content">
          <!-- <Coupon v-model="coupon"/> -->
          <StripeMethod
            @success="onSuccess"
            :plan="plan"
            :coupon="coupon"
            :period="period"
            :price="price"
          />
        </div>
      </template>
    </app-modal-default>
  </app-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Coupon from '@/components/common/Coupon'
import StripeMethod from './StripeMethod';

export default {
  data() {
    return {
      coupon: null,
    }
  },
  props: {
    plan: {},
    period:{},
    price: 0,
  },
  components: {
    Coupon,
    StripeMethod,
  },
  created() {

  },
  methods: {
    onSuccess() {
      this.$store.dispatch('user/updateData');
      this.close();
    },
    close() {
      this.$emit('close');
    }
  },
}
</script>

<style lang="scss" scoped>

.app-modal-default {

  width: 350px;

  .app-loading {
    height: 100%;
    min-height: 200px;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .buttons {
      padding: 50px;
      width: 100%;
    }
  }
}

</style>
